import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import InlineInput from "src/components/inline-input/InlineInput";
import InlineTextArea from "src/components/inline-text-area/InlineTextArea";
import { ReviewFormErrors } from "../ReviewFormModal";

interface ReviewFormProps {
  reviewTitle: string;
  setReviewTitle: Dispatch<SetStateAction<string>>;
  reviewBody: string;
  setReviewBody: Dispatch<SetStateAction<string>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  reviewFormErrors: ReviewFormErrors;
  isFormSubmittedOnce: boolean;
}

const ReviewForm = ({
  reviewTitle,
  setReviewTitle,
  reviewBody,
  setReviewBody,
  setReviewStep,
  reviewFormErrors,
  isFormSubmittedOnce,
}: ReviewFormProps) => {
  const t = useTranslations("ReviewForm");
  return (
    <>
      <section className="my-auto flex w-full flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-center text-2xl font-semibold">
            {t("tell_us_your_thoughts")}
          </h2>
          <p className="text-sm text-gray-600">
            {t("*_indicates_required_fields")}
          </p>
        </div>
        <div className="flex w-full flex-col gap-4 lg:w-2/3">
          <InlineInput
            label={t("review_title_placeholder")}
            value={reviewTitle}
            onChange={(event) => setReviewTitle(event.target.value)}
          />
          <InlineTextArea
            label={t("review_placeholder")}
            value={reviewBody}
            onChange={(event) => setReviewBody(event.target.value)}
          />
        </div>
        <div className="space-y-2">
          {reviewFormErrors.review && (
            <p className="error-message">{reviewFormErrors.review}</p>
          )}
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton
            onClick={() => setReviewStep(9)}
            disabled={!reviewTitle || !reviewBody}
          >
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={!reviewTitle || !reviewBody}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default ReviewForm;
